import React, { useMemo } from 'react';
import { StyleSheet, View } from 'react-native';
import Text from 'design-system/Text';
import { rem, Spacer } from 'design-system';
import IconTransactionCategory from 'features/transactions/icons/IconTransactionCategory';
import { useAppStore } from 'store/hooks';
import ItemBadgeWrapper from './ItemBadgeWrapper';
import IconCover from './icons/IconCover';
import { getCategoryBadgeText } from './getCategoryBadgeText';
const CategoryItemBadge = ({ filter, scrollY, onPress, handleClose, scrollToItem, isActiveKeyboard, }) => {
    const Icons = useMemo(() => {
        const filtersLen = filter.length;
        const slicedFilters = filter.slice(0, 5);
        return (<View style={styles.container}>
        {slicedFilters.map((eachFilter) => (<View key={eachFilter.id} style={filtersLen < 4 && styles.categoryIcon}>
            <IconTransactionCategory width={rem(16)} height={rem(16)} category={eachFilter} emojiBackgroundColor="transparent"/>
          </View>))}
        {filtersLen > 5 && (<View style={styles.gradientContainer}>
            <IconCover scrollY={scrollY}/>
          </View>)}
        {filtersLen >= 4 && <Spacer w={4}/>}
      </View>);
    }, [filter, scrollY]);
    const store = useAppStore();
    const content = useMemo(() => getCategoryBadgeText(filter, store.getState()), [filter]);
    return (<ItemBadgeWrapper scrollY={scrollY} handlePress={onPress} onCancel={handleClose} scrollToItem={scrollToItem} isActiveKeyboard={isActiveKeyboard}>
      <View style={styles.container}>
        {Icons}
        <Text Text-14>{content}</Text>
      </View>
    </ItemBadgeWrapper>);
};
const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    categoryIcon: {
        marginRight: rem(4),
    },
    gradientContainer: {
        top: 0,
        bottom: 0,
        right: rem(4),
        width: rem(24),
        position: 'absolute',
    },
});
export default CategoryItemBadge;
